import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import {
  AuthStatusOptionModel,
  AuthStatusOptionModelResponse,
} from "../../../../../data-model/authStatusOptions";

/**
 * useAuthStatusOptions
 *
 * Custom hook that fetches auth status options from Firestore.
 * Handles loading state and error handling.
 *
 * @param {string} facilityId - The facility ID to fetch auth status options for
 * @param {boolean} isOpen - Whether the modal/dialog is open (controls when to fetch)
 * @returns {object} Return object containing:
 * @returns {AuthStatusOptionModel[]} return.authStatusOptions - Array of auth status options
 * @returns {boolean} return.isLoading - Loading state for the fetch operation
 */
export const useAuthStatusOptions = (facilityId: string, isOpen: boolean) => {
  const [authStatusOptions, setAuthStatusOptions] = useState<
    AuthStatusOptionModel[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen && facilityId) {
      setIsLoading(true);
      FirestoreService.getDocument<AuthStatusOptionModelResponse>(
        FirestoreDocumentReference.authStatusOptions(facilityId),
      )
        .then((response) => {
          setAuthStatusOptions(response.data || []);
        })
        .catch((error) => {
          console.error("Error fetching auth status options:", error);
          setAuthStatusOptions([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [isOpen, facilityId]);

  return {
    authStatusOptions,
    isLoading,
  };
};
